
export default {
    async ObtenerUsuario(vm){
        vm.axios.post(`${vm.domain.domainNameForApi}Configuracion/Obtenerusuario`).then(response => {
            vm.uslogin = response.data;
        })
    },
    async ListadoEstados(vm){
        return vm.axios.post(`${vm.domain.domainNameForApi}Configuracion/ListadoEstados`).then(response => response.data)
    },
    CatalogoEstados(vm){
        vm.axios.post(`${vm.domain.domainNameForApi}Configuracion/CatalogoEstados`).then(response => {
            vm.estados.opcionesEstados = response.data;
        })
    },
    EliminarEstado(vm, id){
        var datos = new FormData();
        datos.append("claves", id);
        return vm.axios.post(`${vm.domain.domainNameForApi}Configuracion/EliminarEstado`, datos).then(response => response.data)
    },
    AgregarEstado(vm, esclaves){
        var datos = new FormData();
        datos.append("esclaves", esclaves);
        return vm.axios.post(`${vm.domain.domainNameForApi}Configuracion/AgregarEstado`, datos).then(response => response.data)
    }

}